import { render, staticRenderFns } from "./ParamsTable.vue?vue&type=template&id=345c08c0&"
import script from "./ParamsTable.vue?vue&type=script&lang=js&"
export * from "./ParamsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports